module.exports = __webpack_public_path__ + "img/slider-1.9a8d1965.png";